// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';
// Lazy-loaded Components
const VendorCreate = lazy(() => import('pages/vendor/vendorCreate'));
const VendorsList = lazy(() => import('pages/vendor/vendorList'));

const VendorRoute = (
  <Route path={routeName.vendorDetails}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.VENDOR_VIEW,
            PrivateRouteConst.SELF_VENDOR_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <VendorsList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_VENDOR}>
          <Suspense fallback={<Loading />}>
            <VendorCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.VENDOR_EDIT,
            PrivateRouteConst.SELF_VENDOR_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <VendorCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.VENDOR_VIEW,
            PrivateRouteConst.SELF_VENDOR_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <VendorCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default VendorRoute;
